import { Vegsystemreferanse } from './omrader';

export class Vegkategori extends Vegsystemreferanse {
    constructor(readonly navn: string, readonly id: string) {
        super(null, null, null, null, id);
    }
}
